module.exports = __webpack_public_path__ + "img/Pic_portfolio.e7d9042d.webp";